module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Attachment#1-69f8c2edc412df7ae011ebbfb7b1f5b1.svg";